import productGallery from "./product-gallery.js";
import productAddons from "./product-addons.js";

if ($(".woocommerce-product-gallery").length) {
  productGallery();
}

if ($("body").hasClass("single-product")) {
  productAddons();
}
